import { render, staticRenderFns } from "./Disciplines.vue?vue&type=template&id=68b7471f&scoped=true&"
import script from "./Disciplines.vue?vue&type=script&lang=js&"
export * from "./Disciplines.vue?vue&type=script&lang=js&"
import style0 from "./Disciplines.vue?vue&type=style&index=0&id=68b7471f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b7471f",
  null
  
)

export default component.exports